import React from 'react';
import useStyles from "examsbook-react-sdk/custom-hooks/useStyles";
import useTranslations from "examsbook-react-sdk/custom-hooks/useTranslations";
import { getQuizStatus, TimeUtils } from "examsbook-react-sdk/common";
import classNames from 'classnames';

/**
 * Quiz result mini on sidebar.
 * @param props
 * @returns {*}
 * @constructor
 */
const QuizCompactResult = props => {
    const { viewMode, questions, timeTaken, duration } = props;
    const { totalMarks, obtained } = getQuizStatus(questions);
    const classes = useStyles(styles)();
    const t = useTranslations();
    let timeSpent;
    if (viewMode) {
        timeSpent = TimeUtils.changeTimeFormat(timeTaken);
    }
    return (
        <div>
            {viewMode ?
                <div className={classNames(classes.totalMarksSection)}>
                    <div className={classNames(classes.totalMarks)}>
                        <span className={classNames(classes.totalMarksText)}>{t('total_marks')}</span>
                        <span className={classNames(classes.totalMarksContainer)}>
                            {parseFloat(obtained).toFixed(2) || 0} / {totalMarks || 0}
                            </span>
                    </div>
                    <div className={classNames(classes.totalMarks)}>
                        <span className={classNames(classes.totalMarksText)}>{t('total_time')}</span>
                        <span
                            className={classNames(classes.totalMarksContainer)}>
                            {timeSpent ? timeSpent : '00:00'} / {duration ? duration : '00:00'} Mins
                        </span>
                    </div>
                </div> : ''}
        </div>
    );
};

const styles = theme => ({
    totalMarksSection: {
        color: '#000',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        marginLeft: 15,
        marginRight: 15,
        borderWidth: 1,
        borderBottomColor: '#eee',
        marginTop: '15px',
        '@media (max-width: 767px)': {
            display: 'none'
        }
    },
    totalMarks: {
        marginBottom: 12,
        display: 'flex',
        flex: 1,
        alignItems: 'center'
    },
    totalMarksText: {
        width: 120,
        color: '#000',
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'left'
    },
    totalMarksContainer: {
        padding: '2px 5px',
        display: 'flex',
        color: '#27AE60',
        backgroundColor: '#27AE600F',
        borderRadius: 2,
        fontSize: 13,
        border: '1px solid #27AE60'
    }
});

export default QuizCompactResult;
